import {ERROR_COLOR} from "../../../../../../../../../themes/themeConfigurator";

const styles = (theme) => ({
  icon: {
    color: theme.palette.primary.main,
    '&.error': {
      color: ERROR_COLOR,
    },
    cursor: 'pointer',
  },
  checkboxLabel: {
    fontFamily: 'Roboto-Regular'
  }
});

export default styles;